import LetterGroup from "./LetterGroup";

export default function LetterGroups(props) {
    const { items, render, selector } = props;

    const letters = items.map(selector).filter((e, i, a) => a.indexOf(e) === i).sort();

    return letters.map(
        (letter) => (
            <LetterGroup
                key={ letter }
                letter={ letter }
                members={ items.filter((item) => selector(item) === letter) }
                render={ render }
            />
        )
    );
}
